<template>
  <messenger-chat-survey-log-message-layout :rate="logItem.rate">
    <widget-translate
      keypath="chat.youRatedChat"
      tag="div"
      class="d-flex align-center gap-2"
    >
      <template v-slot:rating>
        <span
          class="d-inline-flex align-center"
          :class="logItem.rate === 'good' ? 'success--text' : 'error--text'"
        >
          <widget-icon
            class="mr-1"
            size="18px"
            :name="logItem.rate === 'good' ? 'thumb_up' : 'thumb_down'"
          />
          <span class="font-weight-semi-bold">
            {{ $t(`chat.${logItem.rate}`) }}
          </span>
        </span>
      </template>
    </widget-translate>
  </messenger-chat-survey-log-message-layout>
</template>

<script lang="ts" setup>
import type { MessengerChatRatedLogMessageListItem } from '@widgets/messenger/types/chat/message'
import WidgetTranslate from '@widgets/shared/components/WidgetTranslate.vue'
import MessengerChatSurveyLogMessageLayout from '@widgets/messenger/components/messages/MessengerChatSurveyLogMessageLayout.vue'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'

defineProps<{
  logItem: MessengerChatRatedLogMessageListItem
}>()
</script>
